
import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import WalletCard from '../../components/card/walletCard/walletCard';
import WalletLoanCard from '../../components/card/walletCard/walletLoanCard';
import EmptyStyle from '../../components/emptyStyles/emptyStyle';
import { SALE_ID, WALLET_KEY } from '../../config/cacheKey';
import { IGetCustomerWalletsInfoResponse, IGetWalletTransactionsResponse } from '../../models/wallet.model';
import { changeRouteType, getpervInnerState } from '../../redux/handleBackBtn/handleBackBtnSlice';
import { setHeaderTitle } from '../../redux/headerTitle/headerTitleSlice';
import { GetWalletTransactions } from '../../services/wallet.service';
import './walletFlow.css';
import WalletFlowSkeleton from './walletFlowSkeleton';
import { IStoreContainerOriginal } from '../navigationButtonComponents/walletContainer/IStoreContainer';
import EmptyLoanStyle from '../../components/icons/EmptyLoanStyle';

export default function WalletFlow({ setState }: IStoreContainerOriginal) {
    const [walletTransactions, setWalletTransactions] = useState<IGetWalletTransactionsResponse[]>([])
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const randomKeyForDispatch = Math.random();
    const walletKey: string = queryClient.getQueryData(WALLET_KEY)!;
    const wallets: IGetCustomerWalletsInfoResponse[] = queryClient.getQueryData('wallets')!
    const selectedWallet = wallets?.filter((wallet) => wallet?.key === walletKey);

    const { mutate: GetWalletTransactionsMutate, isLoading } = useMutation(GetWalletTransactions, {
        onSuccess: (data: IGetWalletTransactionsResponse[]) => {
            if (data) {
                setWalletTransactions(data)
            }
        },
        onError: () => { },
    });


    useEffect(() => {
        queryClient.removeQueries(SALE_ID);
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: `wallet ${randomKeyForDispatch}` }));
        dispatch(setHeaderTitle({ header: 'گردش کیف پول', color: 'var(--input-bg-color)', parentRoute: 'store' }));
    }, [])

    useEffect(() => {
        GetWalletTransactionsMutate({
            walletKey
        })

    }, [walletKey])

    const handlePurchaseDetail = (saleId: number) => {
        if (saleId) {

            setState!('purchaseRecordDetail');
            queryClient.setQueryData(SALE_ID, saleId)
        }
    }


    if (isLoading) {
        return <WalletFlowSkeleton />
    }


    return (
        <>
            <Grid container spacing={2} sx={{ paddingTop: "1rem", width: '100%', height: "calc(100svh - 120px)" }}>
                <Grid
                    xs={12}
                    sx={{
                        background: 'var(--input-bg-color)',
                        height: '150px',
                        display: 'flex',
                        alignItems: 'center',
                        paddingInline: "40px"
                    }}
                >
                    <WalletLoanCard amount={selectedWallet[0]?.balance} date={selectedWallet[0]?.expirationDatePersian} title={selectedWallet[0]?.title} color={selectedWallet[0]?.colorHexCode} />

                </Grid>
                <Grid
                    xs={12}
                    sx={{
                        paddingX: '1em',
                        height: "1000px",
                        paddingTop: "18px",
                        maxHeight: "70%",
                        overflowX: "auto"
                    }}
                >
                    {walletTransactions.length === 0
                        ?
                        <div className='w-full h-[25%]'>

                            <EmptyStyle icon={<EmptyLoanStyle className='text-[var(--primary-text-color)]' />} text={'تاکنون تراکنشی  ثبت نشده است.'} emphasisedWords={['تراکنشی']} emphasisedWordsColor={'#BBA57A'} />
                        </div>
                        : walletTransactions?.map((transaction: IGetWalletTransactionsResponse, index: number) => (
                            <WalletCard key={index} {...transaction} purchaseDetail={() => handlePurchaseDetail(transaction.saleId)} />
                        ))}
                </Grid>
            </Grid >
        </>

    );
}
